import React, { useEffect, useState } from 'react';
import { Modal, Spin, Empty, message } from 'antd';
import { makeGetCall } from '../../../utils/helper';

type Props = {
  open: boolean;
  bookmarkId: number | null;
  onClose: () => void;
};

const ReportDialog: React.FC<Props> = ({ open, bookmarkId, onClose }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !bookmarkId) return;

    let revokedUrl: string | null = null;
    let cancelled = false;

    setLoading(true);
    setError(null);
    setPdfUrl(null);

    makeGetCall(`/library/bookmarks/${bookmarkId}/report`, { responseType: 'blob' })
      .then(res => {
        if (cancelled) return;
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        revokedUrl = url;
        setPdfUrl(url);
      })
      .catch(err => {
        if (cancelled) return;
        const msg =
          err?.response?.status === 404
            ? 'Report not available for this study'
            : err?.response?.data?.message || 'Failed to load report';
        setError(msg);
        message.error(msg);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
      if (revokedUrl) URL.revokeObjectURL(revokedUrl);
    };
  }, [open, bookmarkId]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      title="Report"
      destroyOnClose
      className="viewer-modal"
      bodyStyle={{ padding: 0, height: '75vh' }}
    >
      <div style={{ width: '100%', height: '100%', position: 'relative', background: '#525659' }}>
        {loading && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spin tip="Loading report..." />
          </div>
        )}

        {!loading && error && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
            <Empty description={error} />
          </div>
        )}

        {!loading && !error && pdfUrl && (
          <object
            data={`${pdfUrl}#toolbar=1&navpanes=0&view=FitH`}
            type="application/pdf"
            width="100%"
            height="100%"
            style={{ border: 'none', display: 'block' }}
          >
            <div style={{ padding: 24, textAlign: 'center', background: '#fff' }}>
              Your browser can't display this PDF inline.{' '}
              <a href={pdfUrl} target="_blank" rel="noreferrer" style={{ color: '#1677ff' }}>
                Open in new tab
              </a>
            </div>
          </object>
        )}
      </div>
    </Modal>
  );
};

export default ReportDialog;
